import { useCallback, useContext } from "react";
import { GlobalContext } from "../App";
import { Language } from "../types/types";
import enUS from "./en-US.json";
import zhCN from "./zh-CN.json";

type Key = keyof typeof zhCN;

const LanguageMap: Record<Language, typeof zhCN> = {
  "en-US": enUS,
  "zh-CN": zhCN,
};

export const useTranslation = () => {
  const { language } = useContext(GlobalContext);

  const t = useCallback((key: Key) => LanguageMap[language][key], [language]);

  return {
    t,
  };
};
